document.addEventListener('DOMContentLoaded', function () {

  const zz = /** @type {any} */ (window).z;
  document.addEventListener('zrzs:add-to-cart', processAddToCartEvent);

  /**
   * @param {string} text
   * @param {any|undefined|null} extra
   * @returns {void}
   */
  function zlog(text, extra = null) {
    if (extra) {
      console.log(`|z:z| ${text}`, extra);
      return;
    }
    console.log(`|z:z| ${text}`);
  }

  /**
   * detail { items }
   *
   * @param { CustomEvent } event
   */
  function processAddToCartEvent(event) {
    try {
      zlog('processing zrzs:add-to-cart event...');
      const { items } = event.detail;
      localStorage.setItem('zrzs_event_add_to_cart', JSON.stringify(items));
    } catch (error) {
      console.error(`|z:z| error processing zrzs:add-to-cart event: ${error.message}`);
    }
  }

  async function sendAddToCartEventToCrmPixelProxy() {
    try {
      console.log('|z:z| sending added items to crm pixel proxy...');

      const json = localStorage.getItem('zrzs_event_add_to_cart');
      localStorage.removeItem('zrzs_event_add_to_cart');
      if (!json) {
        console.log('|z:z| no items to send to crm pixel proxy');
        return;
      }

      const crmPixelProxyOn = zz.crm_pixel_proxy_on === 'true';
      if (!crmPixelProxyOn) {
        console.log('|z:z| crm pixel proxy off, not sending added items to crm pixel proxy');
        return;
      }

      // verificar se a página corrente é a página de carrinho (se inicia com /cart)
      if (!document.location.pathname.startsWith('/cart')) {
        console.log('|z:z| not cart page, not sending added items to crm pixel proxy');
        return;
      }

      const crmEligibleCustomerListForShopifyAddedCartConfig = (zz.crm_eligible_customer_list_for_shopify_added_cart || '').trim();
      if (crmEligibleCustomerListForShopifyAddedCartConfig?.length > 0)
      {
        const crmEligibleCustomerListForShopifyAddedCartList = crmEligibleCustomerListForShopifyAddedCartConfig.split(',');
        if (!crmEligibleCustomerListForShopifyAddedCartList.includes(zz.customer_id)) {
          console.log('|z:z| customer not eligible for shopify added to cart, not sending added items to crm pixel proxy');
          return;
        }
      }

      const items = JSON.parse(json);

      const response = await fetch('/cart.js');
      const cart = await response.json();

      const payload = {
        event: 'added_to_cart',
        token: cart.token,
        customerId: zz.customer_id ? Number(zz.customer_id) : null,
        items: items.map((/** @type {any} */ item) => ({
          variantId: Number(item.id),
          quantity: Number(item.quantity),
        }))
      }

      const zerezesPixelProxyBaseAddress = zz.zerezes_pixel_proxy_base_address || '';
      if (!zerezesPixelProxyBaseAddress) {
        console.log('|z:z| zerezes pixel proxy base address not configured, not sending added items to crm pixel proxy');
        return;
      }
      const zerezesPixelProxyEventsRoute = zz.zerezes_pixel_proxy_events_route || '';
      if (!zerezesPixelProxyEventsRoute) {
        console.log('|z:z| zerezes pixel proxy events route not configured, not sending added items to crm pixel proxy');
        return;
      }

      const xapiKey = zz.crm_pixel_proxy_x_api_key || '';
      const url = `${zerezesPixelProxyBaseAddress}${zerezesPixelProxyEventsRoute}`;

      console.log('|z:z| sending added items to crm pixel proxy...');

      await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': xapiKey,
        },
        body: JSON.stringify(payload),
      });
    } catch (error) {
      console.error(`|z:z| error sending added items to crm pixel proxy: ${error instanceof Error ? error.message : String(error)}`);
    }
  }

  function init() {
    sendAddToCartEventToCrmPixelProxy();
  }

  init();
  
});